import SaveButton from 'components/buttons/SaveButton';
import SelectInput from 'components/input-field/SelectInput';
import TextInput from 'components/input-field/TextInput'
import { Form, Formik } from 'formik';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Col, Row } from 'reactstrap';
import Loader from 'components/loader/Loader';
import { TestSchema } from './Validation';
import { AddTestRes, AddTestTodo } from 'redux/slice/admin/master/test/AddTest';

class AddTest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spiner: false,
            values: {
                test: '',
                url:'',
                status: ''
            }
        };
    }

    status_option = [
        { "value": 'Active', "label": "Active" },
        { "value": 'Inactive', "label": "Inactive" }
    ]

    handleSubmit = (values) => {
        this.setState({ spiner: true });
        const { dispatch } = this.props;
        dispatch(AddTestTodo(values)).then(() => this.add_res());

    }


    add_res = () => {
        if (AddTestRes?.success) {
            toast.success(AddTestRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                this.props.history.push('/admin/test-list');
            }, 1500);
            this.setState({ spiner: false });
        } else {
            toast.error(AddTestRes?.message, { position: "bottom-right" });
            this.setState({ spiner: false });
        }
    }

    render() {
        return (
            <>
                <div className='form_layout'>
                    {this.state.spiner ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :

                        <Formik
                            initialValues={this.state.values}
                            validationSchema={TestSchema}
                            onSubmit={this.handleSubmit}
                        >
                            {({
                                values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                <Form>
                                    <Row>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Test'
                                                placeholder=''
                                                name='test'
                                                value={values.test || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.test && touched.test ? (<span className='text-danger form_label' >{errors.test}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Api URL'
                                                placeholder=''
                                                name='url'
                                                value={values.url || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.url && touched.url ? (<span className='text-danger form_label' >{errors.url}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='Status'
                                                disabled={false}
                                                options={this.status_option}
                                                name='status'
                                                defaultValue={''}
                                                onChange={(e) =>
                                                    setFieldValue('status', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null} />
                                        </Col>
                                        <Col xl='12' className='d-flex justify-content-end'>
                                            <SaveButton name={'SAVE'} />
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                    }
                </div>
                <ToastContainer />

            </>
        )
    }
}
export default connect()(withRouter(AddTest));
